module.exports = __webpack_public_path__ + "img/no_photos.a37b37d9.png";